import { AbsencesCalendar } from "@/components/absences/absences-calendar";
import { useAbsencesCalendar } from "@/components/absences/absences-calendar/use-absences-calendar";
import { AbsencesInbox } from "@/components/absences/absences-inbox";
import { ContentBox } from "@msuite/ui/content-box";
import { useState } from "react";

export function UserAbsences() {
	/** State */
	const [searchValue, setSearchValue] = useState("");

	const controller = useAbsencesCalendar();

	/** Render */
	return (
		<ContentBox bottomPadding="none">
			<div
				className="grid grid-cols-2 h-full min-h-0 overflow-hidden gap-8"
				style={{
					gridTemplateColumns: "minmax(350px, max-content) 1fr",
				}}
			>
				<AbsencesInbox
					searchValue={searchValue}
					onSearch={setSearchValue}
				/>
				<AbsencesCalendar
					controller={controller}
					searchValue={searchValue}
				/>
			</div>
		</ContentBox>
	);
}
